module.exports = "https://static.futunn.com/components/common-redpacket-prize-list/images/no-crowd-nn.9344b1b71a.png";